import { defineMessages } from 'react-intl'

export const sectionNames = defineMessages({
  apps: {
    defaultMessage: 'Apps',
    description: 'apps section name',
  },
  businessEntities: {
    defaultMessage: 'Business entities',
    description: 'business entities section name',
  },
  campaigns: {
    defaultMessage: 'Campaigns',
    description: 'section name',
  },
  caseActionResults: {
    defaultMessage: 'Case action results',
    description: 'section name',
  },
  caseActionTypes: {
    defaultMessage: 'Case action types',
    description: 'section name',
  },
  caseCloseReasons: {
    defaultMessage: 'Case close reasons',
    description: 'section name',
  },
  caseTags: {
    defaultMessage: 'Case tags',
    description: 'section name',
  },
  caseTypes: {
    defaultMessage: 'Case types',
    description: 'section name',
  },
  cases: {
    defaultMessage: 'Cases',
    description: 'cases section name',
  },
  casesAll: {
    defaultMessage: 'All cases',
    description: 'cases section name',
  },
  casesReminders: {
    defaultMessage: 'Reminders',
    description: 'cases section name — the reminders calendar',
  },
  casesTeamAssigned: {
    defaultMessage: "My team's cases",
    description: 'cases section name',
  },
  casesUserAssigned: {
    defaultMessage: 'My cases',
    description: 'cases section name',
  },
  channels: {
    defaultMessage: 'WhatsApp channels',
    description: 'channels section name',
  },
  configuration: {
    defaultMessage: 'Configuration',
    description: 'configuration section name',
  },
  customers: {
    defaultMessage: 'Customers',
    description: 'customers section name',
  },
  financialAccountTypes: {
    defaultMessage: 'Financial accounts types',
    description: 'apps section name',
  },
  financialProviders: {
    defaultMessage: 'Financial providers',
    description: 'cases section name',
  },
  home: {
    defaultMessage: 'Home',
    description: 'home section name',
  },
  leadQueues: {
    defaultMessage: 'Lead queues',
    description: 'lead queues section name — import quarantine + merge review',
  },
  messages: {
    defaultMessage: 'Messages',
    description: 'messaging section name',
  },
  oversightScenarios: {
    defaultMessage: 'Oversight scenarios',
    description: 'oversight scenarios section name',
  },
  playbooks: {
    defaultMessage: 'Bot playbooks',
    description: 'playbooks section name',
  },
  productPackages: {
    defaultMessage: 'Product packages',
    description: 'cases section name',
  },
  products: {
    defaultMessage: 'Products',
    description: 'cases section name',
  },
  reportAcquisitionFunnel: {
    defaultMessage: 'Acquisition funnel',
    description: 'navigation report',
  },
  reportAssignedLeads: {
    defaultMessage: 'Assigned leads',
    description: 'cases section name',
  },
  reportFees: {
    defaultMessage: 'Fees',
    description: 'navigation report',
  },
  reportLeadDuplicates: {
    defaultMessage: 'Lead duplicates',
    description: 'navigation report',
  },
  reportMessaging: {
    defaultMessage: 'Messaging',
    description: 'navigation report',
  },
  reportNewLeads: {
    defaultMessage: 'New leads',
    description: 'cases section name',
  },
  reportUserActivity: {
    defaultMessage: 'User activity',
    description: 'navigation report',
  },
  reports: {
    defaultMessage: 'Reports',
    description: 'users section name',
  },
  safetyTerms: {
    defaultMessage: 'Safety terms',
    description: 'outbound safety word list section name',
  },
  ticketActionResults: {
    defaultMessage: 'Ticket action results',
    description: 'section name',
  },
  ticketActionTypes: {
    defaultMessage: 'Ticket action types',
    description: 'section name',
  },
  ticketCloseReasons: {
    defaultMessage: 'Ticket close reasons',
    description: 'section name',
  },
  ticketTags: {
    defaultMessage: 'Ticket tags',
    description: 'section name',
  },
  tickets: {
    defaultMessage: 'Tickets',
    description: 'tickets section name',
  },
  ticketsAll: {
    defaultMessage: 'All tickets',
    description: 'tickets section name',
  },
  ticketsTeamAssigned: {
    defaultMessage: "My team's tickets",
    description: 'tickets section name',
  },
  ticketsUserAssigned: {
    defaultMessage: 'My tickets',
    description: 'tickets section name',
  },
  userTeams: {
    defaultMessage: 'User teams',
    description: 'user teams section name',
  },
  users: {
    defaultMessage: 'Users',
    description: 'users section name',
  },
})
